import CustomTable from '../../../CustomTable/CustomTable';
import { TLoadCommoditiesContainerProps } from './LoadCommoditiesContainer.type';
import './LoadCommoditiesContainer.scss';

const LoadCommoditiesContainer = (props: TLoadCommoditiesContainerProps) => {
  const { commodities, modalView } = props;

  const topCommodities = commodities?.slice(0, 4);
  const AdditionalCommodities =
    commodities?.length > 3 ? commodities?.slice(4, commodities?.length) : [];

  return (
    <div className="LoadCommoditiesContainer">
      {
        <CustomTable
          data={topCommodities}
          tableColumnTitle={['Description', 'Packaging Type']}
          tableLabel={modalView ? '' : 'Commodity Detail'}
          additionalClass="Commodities_Details"
          modalView={modalView}
        />
      }
      {!!AdditionalCommodities?.length && (
        <CustomTable
          data={AdditionalCommodities}
          tableLabel="Additional Commodities"
          additionalClass="Additional_Commodities"
          tableLabelActionBtnVisibility={true}
        />
      )}
    </div>
  );
};

export default LoadCommoditiesContainer;
